import { Component } from '@angular/core';

@Component({
  selector: 'app-dialog-registrations-closed',
  templateUrl: './dialog-registrations-closed.component.html',
  styleUrls: ['./dialog-registrations-closed.component.scss']
})
export class DialogRegistrationsClosedComponent {

}
